// extracted by mini-css-extract-plugin
module.exports = {"iconDefault":"common-CollectionButton__iconDefault--3tA1R","iconActive":"common-CollectionButton__iconActive--300B4","isActive":"common-CollectionButton__isActive--13rZA"};